<template>
  <div>
    <div
      class="progress is-large"
      v-bind:style="{
        backgroundColor: color,
        width: long ? data.percentage + '%' : 'fit-content',
      }"
    >
      <span>
        {{ currency }} {{ decimal(data.cost) }}
        <small>{{ decimal(data.consumption) }} kWh</small>
      </span>

      <span style="margin-left: 10px">{{ data.percentage.toFixed(0) }}%</span>
    </div>
  </div>
</template>

<script>
import zapp from "@/util/zapp";

export default {
  name: "progress-bar",
  props: ["color", "data", "currency", "long"],
  data() {
    return {};
  },
  computed: {},
  methods: {
    decimal: (number) => zapp.getFormattedDecimal(number),
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.progress {
  color: white;
  font-weight: bolder;
  padding: 0 0.5em;
  border-radius: 25px;
  display: flex;
  justify-content: space-between;
  min-width: 200px !important;
}
</style>
